module.exports = __webpack_public_path__ + "static/media/channel_edit.8e9a7f8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/liveroom/channel_edit.png
// module id = 1941
// module chunks = 6